var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmazonUsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.740234,
    y: 0.954224,
    width: 21,
    height: 15,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5728_64460",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.740234,
    y: 0.954224,
    width: 21,
    height: 15,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5728_64460)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7402 0.954224H0.740234V1.95422H21.7402V0.954224ZM21.7402 2.95422H0.740234V3.95422H21.7402V2.95422ZM0.740234 4.95422H21.7402V5.95422H0.740234V4.95422ZM21.7402 6.95422H0.740234V7.95422H21.7402V6.95422ZM0.740234 8.95422H21.7402V9.95422H0.740234V8.95422ZM21.7402 10.9542H0.740234V11.9542H21.7402V10.9542ZM0.740234 12.9542H21.7402V13.9542H0.740234V12.9542ZM21.7402 14.9542H0.740234V15.9542H21.7402V14.9542Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.740234,
    y: 0.954224,
    width: 9,
    height: 7,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5728_64460)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74023 2.45422C2.74023 2.73037 2.51638 2.95422 2.24023 2.95422C1.96409 2.95422 1.74023 2.73037 1.74023 2.45422C1.74023 2.17808 1.96409 1.95422 2.24023 1.95422C2.51638 1.95422 2.74023 2.17808 2.74023 2.45422ZM4.74023 2.45422C4.74023 2.73037 4.51638 2.95422 4.24023 2.95422C3.96409 2.95422 3.74023 2.73037 3.74023 2.45422C3.74023 2.17808 3.96409 1.95422 4.24023 1.95422C4.51638 1.95422 4.74023 2.17808 4.74023 2.45422ZM6.24024 2.95422C6.51638 2.95422 6.74024 2.73037 6.74024 2.45422C6.74024 2.17808 6.51638 1.95422 6.24024 1.95422C5.96409 1.95422 5.74023 2.17808 5.74023 2.45422C5.74023 2.73037 5.96409 2.95422 6.24024 2.95422ZM8.74024 2.45422C8.74024 2.73037 8.51638 2.95422 8.24024 2.95422C7.96409 2.95422 7.74023 2.73037 7.74023 2.45422C7.74023 2.17808 7.96409 1.95422 8.24024 1.95422C8.51638 1.95422 8.74024 2.17808 8.74024 2.45422ZM3.24023 3.95422C3.51638 3.95422 3.74023 3.73037 3.74023 3.45422C3.74023 3.17808 3.51638 2.95422 3.24023 2.95422C2.96409 2.95422 2.74023 3.17808 2.74023 3.45422C2.74023 3.73037 2.96409 3.95422 3.24023 3.95422ZM5.74023 3.45422C5.74023 3.73037 5.51638 3.95422 5.24023 3.95422C4.96409 3.95422 4.74023 3.73037 4.74023 3.45422C4.74023 3.17808 4.96409 2.95422 5.24023 2.95422C5.51638 2.95422 5.74023 3.17808 5.74023 3.45422ZM7.24023 3.95422C7.51638 3.95422 7.74023 3.73037 7.74023 3.45422C7.74023 3.17808 7.51638 2.95422 7.24023 2.95422C6.96409 2.95422 6.74023 3.17808 6.74023 3.45422C6.74023 3.73037 6.96409 3.95422 7.24023 3.95422ZM8.74024 4.45422C8.74024 4.73037 8.51638 4.95422 8.24024 4.95422C7.96409 4.95422 7.74023 4.73037 7.74023 4.45422C7.74023 4.17808 7.96409 3.95422 8.24024 3.95422C8.51638 3.95422 8.74024 4.17808 8.74024 4.45422ZM6.24024 4.95422C6.51638 4.95422 6.74024 4.73037 6.74024 4.45422C6.74024 4.17808 6.51638 3.95422 6.24024 3.95422C5.96409 3.95422 5.74023 4.17808 5.74023 4.45422C5.74023 4.73037 5.96409 4.95422 6.24024 4.95422ZM4.74023 4.45422C4.74023 4.73037 4.51638 4.95422 4.24023 4.95422C3.96409 4.95422 3.74023 4.73037 3.74023 4.45422C3.74023 4.17808 3.96409 3.95422 4.24023 3.95422C4.51638 3.95422 4.74023 4.17808 4.74023 4.45422ZM2.24023 4.95422C2.51638 4.95422 2.74023 4.73037 2.74023 4.45422C2.74023 4.17808 2.51638 3.95422 2.24023 3.95422C1.96409 3.95422 1.74023 4.17808 1.74023 4.45422C1.74023 4.73037 1.96409 4.95422 2.24023 4.95422ZM3.74023 5.45422C3.74023 5.73037 3.51638 5.95422 3.24023 5.95422C2.96409 5.95422 2.74023 5.73037 2.74023 5.45422C2.74023 5.17808 2.96409 4.95422 3.24023 4.95422C3.51638 4.95422 3.74023 5.17808 3.74023 5.45422ZM5.24023 5.95422C5.51638 5.95422 5.74023 5.73037 5.74023 5.45422C5.74023 5.17808 5.51638 4.95422 5.24023 4.95422C4.96409 4.95422 4.74023 5.17808 4.74023 5.45422C4.74023 5.73037 4.96409 5.95422 5.24023 5.95422ZM7.74023 5.45422C7.74023 5.73037 7.51638 5.95422 7.24023 5.95422C6.96409 5.95422 6.74023 5.73037 6.74023 5.45422C6.74023 5.17808 6.96409 4.95422 7.24023 4.95422C7.51638 4.95422 7.74023 5.17808 7.74023 5.45422ZM8.24024 6.95422C8.51638 6.95422 8.74024 6.73037 8.74024 6.45422C8.74024 6.17808 8.51638 5.95422 8.24024 5.95422C7.96409 5.95422 7.74023 6.17808 7.74023 6.45422C7.74023 6.73037 7.96409 6.95422 8.24024 6.95422ZM6.74024 6.45422C6.74024 6.73037 6.51638 6.95422 6.24024 6.95422C5.96409 6.95422 5.74023 6.73037 5.74023 6.45422C5.74023 6.17808 5.96409 5.95422 6.24024 5.95422C6.51638 5.95422 6.74024 6.17808 6.74024 6.45422ZM4.24023 6.95422C4.51638 6.95422 4.74023 6.73037 4.74023 6.45422C4.74023 6.17808 4.51638 5.95422 4.24023 5.95422C3.96409 5.95422 3.74023 6.17808 3.74023 6.45422C3.74023 6.73037 3.96409 6.95422 4.24023 6.95422ZM2.74023 6.45422C2.74023 6.73037 2.51638 6.95422 2.24023 6.95422C1.96409 6.95422 1.74023 6.73037 1.74023 6.45422C1.74023 6.17808 1.96409 5.95422 2.24023 5.95422C2.51638 5.95422 2.74023 6.17808 2.74023 6.45422Z",
    fill: "url(#paint0_linear_5728_64460)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5728_64460",
    x: 1.74023,
    y: 1.95422,
    width: 7,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5728_64460"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5728_64460",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5728_64460",
    x1: 1.74023,
    y1: 1.95422,
    x2: 1.74023,
    y2: 6.95422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonUsIcon);
export default __webpack_public_path__ + "static/media/amazon-us-icon.d0189299b19123c926d510213f991b5a.svg";
export { ForwardRef as ReactComponent };